export const BASE_URL = 'https://metadefender.opswat.com/';
export const BASE_FQDN_URL = 'https://metadefender.opswat.com/';

export const API = {
    backend: {
        baseUrl: 'api',
        defaultTimeout: 100000
    },
    google: {
        key: 'AIzaSyDBjLEUj_fi0uPK7rhlllsTyMNxIl8TvIA'
    },
    facebook: {
        appId: '737835536327065'
    },
    reCaptcha: {
        key: '6LcI7RoUAAAAAOIqgDbeaTbledWQV_OvmgrC88Hb'
    },
    optimizely: {
        key: '4854881795',
    }
};
